// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/message.css
// module id = 2450
// module chunks = 2